import { MButton } from '@assets/mui/@material-extend';
import React, { useState } from 'react';

import { RouteWidgetBaseParameters } from '../../../types';
import { CargoSelectionDialog } from './CargoSelectionDialog';
import { CargoSelectionType } from './types';
import { useTranslation } from 'react-i18next';

interface CargoSelectionProps {
  isActionsDisabled: boolean;
  BaseData: RouteWidgetBaseParameters;
  mainLanguage: string; // Текущий основной язык
  cargoSelectionType: CargoSelectionType;
}

function CargoSelection({
  isActionsDisabled,
  BaseData,
  mainLanguage,
  cargoSelectionType,
}: CargoSelectionProps) {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const { t } = useTranslation('Common');

  const openDialogHandler = () => {
    setIsDialogOpen(true);
  };

  const closeDialogHandler = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <div>
        <MButton
          variant={'outlined'}
          color={'primary'}
          className="cargo-params-select-btn"
          disabled={isActionsDisabled}
          onClick={openDialogHandler}
        >
          {t("Common:CargoSelection.SelectionButton")}
        </MButton>
      </div>
      <CargoSelectionDialog
        BaseData={BaseData}
        isActionsDisabled={isActionsDisabled}
        mainLanguage={mainLanguage}
        cargoSelectionType={cargoSelectionType}
        isDialogOpen={isDialogOpen}
        onCloseDialog={closeDialogHandler}
      />
    </>
  );
}

export { CargoSelection };
